import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-loading-content-placeholder',
  templateUrl: './loading-content-placeholder.component.html'
})
export class LoadingContentPlaceholderComponent implements OnInit {

  @Input() config: LoadingContentPlaceholderConfig;

  ConfigType = LoadingContentPlaceholderType;
  CellSize = LoadingContentPlaceholderCellSize;

  constructor() { }

  ngOnInit() {
  }

  private init(): void {

  }

}

export enum LoadingContentPlaceholderType {
  SIMPLE = 'SIMPLE', // for same size cells
  ADVANCED = 'ADVANCED', // for different sized cells
}

export interface LoadingContentPlaceholderCellConfig {
  size: LoadingContentPlaceholderCellSize
}

export interface LoadingContentPlaceholderRowConfig {
  cells: LoadingContentPlaceholderCellConfig[];
}

export enum LoadingContentPlaceholderCellSize {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export interface LoadingContentPlaceholderConfig {
  type: LoadingContentPlaceholderType;

  // simple config properties - for same size cells
  rowsAmount?: number;
  columnsAmount?: number;
  cellSize?: LoadingContentPlaceholderCellSize;

  // advanced config properties - for different sized cells
  rows?: LoadingContentPlaceholderRowConfig[];
}
